﻿import { Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getToday, hasPermission } from "@/services/Utils";

import ButtonFilter from "@/components/Filter/ButtonFilter";

import { useApplicationOrdersPaginate } from "@/hooks/planning/application-order/applicationOrders";
import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";

import classes from "./orderApplicationAction.module.scss";

const AppOrdersAction = ({ showFilter, setShowFilter, filters }) => {
	const { data } = useApplicationOrdersPaginate(filters);
	const { permissions } = data;

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { filter } = useSelector((state) => state.auth);

	const exportExcel = () => {
		const filename = `${location.pathname.replace("/", "")}  ${getToday()}.xlsx`;

		const params = {
			...filters,
			...filter,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: params,
					show: true,
					url: "/client/application_orders/excel",
					name: filename,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	const exportBook = () => {
		const filename = `Cuaderno de campo ${getToday()}.xlsx`;
		const params = {
			...filters,
			...filter,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: params,
					show: true,
					url: "/client/application_orders/book_field/excel",
					name: filename,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} style={{ justifyContent: "right", display: "flex" }}>
				{hasPermission("create", permissions) && (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							navigate(`/orden_aplicacion/ingresar`);
						}}
					>
						<span>Cargar</span>
					</div>
				)}

				<DropdownButton id="dropdown-button-excel" title="Descargar Excel">
					<Dropdown.Item onClick={() => exportExcel()}>Orden de aplicacion</Dropdown.Item>
					<Dropdown.Item onClick={() => exportBook()}>Cuaderno de campo</Dropdown.Item>
				</DropdownButton>
			</Col>
		</Row>
	);
};

export default AppOrdersAction;
